import BaseClass from "../BaseClass.js";

export default class Deleteable extends BaseClass {
    constructor(element) {
        super(element);

        this.deleteListener = null;
        this.id = null;
        this.init();

    }

    delete(data) {
        if (this.elementID != null && this.elementID == data.elementId) {
            this.$element.remove();
        }
    }

    init() {
        const mySelf = this;

        this.deleteListener = function (event, data) {
            mySelf.delete(data);
        }

        $(document).on('content:delete', this.deleteListener)

    }

    destroyListener() {
        this.$element.off('element:delete', this.deleteListener)
    }
}